import { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { LinkCaption } from '../../styles/LinkStyle';

const Container = styled.div`
  //tablet or larger
  @media (min-width: 496px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (min-width: 496px) {
    display: contents;
  }
`;
const CookiesLink: FunctionComponent<Record<string, never>> = (): ReactElement => {
  return (
    <Container>
      <Row>
        <LinkCaption id="pref-cookies" href="#">
          <span className="optanon-show-settings">Préférences des cookies</span>
        </LinkCaption>
        <LinkCaption
          id="politique-cookies"
          target="_blank"
          href={(window as unknown as WindowWithEnv)._env_.cookiesUrl}
        >
          Politique des cookies
        </LinkCaption>
      </Row>
      <LinkCaption
        id="mentions-legales"
        target="_blank"
        href={(window as unknown as WindowWithEnv)._env_.mentionsLegalesUrl}
      >
        Mentions légales
      </LinkCaption>
    </Container>
  );
};

export default CookiesLink;
